import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { serviceurl } from 'src/app/constant/constant';

@Injectable({
  providedIn: 'root'
})
export class DeadRetiredService {

  url:string = serviceurl + 'characters/'
  constructor(
    private http:HttpClient
  ) { }

  retireCharacter(character_id:number , payload :any){
    return this.http.post(this.url + 'retire/' +character_id +'/',payload)
  }

  markCharacterAsdead(character_id,payload:any){
    return this.http.post(this.url+ 'dead/' +character_id +'/',payload)
  }
}
